module.exports = __webpack_public_path__ + "media/assets/img/flags/ja-JP-af2377f2029a3632bc294262b9a5cf40.png";